var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 376.79999,
    height: 296.5,
    viewBox: "0 0 376.79999 296.5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style997",
    type: "text/css"
  }, "\n\t.st0{fill:#2A4C87;}\n\t.st1{fill:#2E4E88;}\n\t.st2{fill:#1F3D70;}\n\t.st3{fill:#194C88;}\n\t.st4{fill:#3468A3;}\n\t.st5{fill:#4C8DCB;}\n\t.st6{fill:#3498B3;}\n\t.st7{fill:#0AA496;}\n\t.st8{fill:#00AA75;}\n\t.st9{fill:#4FBA6A;}\n\t.st10{fill:#7EC45F;}\n\t.st11{fill:#4C609B;}\n\t.st12{fill:#54669F;}\n\t.st13{fill:#746FA7;}\n\t.st14{fill:#99558E;}\n\t.st15{fill:#AF3379;}\n\t.st16{fill:#BE266A;}\n\t.st17{fill:#D4525C;}\n\t.st18{fill:#E0654F;}\n\t.st19{fill:#F57F2A;}\n\t.st20{fill:#F89828;}\n\t.st21{fill:#FEC127;}\n\t.st22{fill:#FED627;}\n\t.st23{fill:#351A55;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path999",
    className: "st0",
    d: "m341.1 116.4c2.1 8 10.3 12.8 18.4 10.6 8-2.1 12.8-10.3 10.6-18.4-2.1-8-10.3-12.8-18.4-10.6-7.9 2.2-12.7 10.4-10.6 18.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1001",
    className: "st0",
    d: "m320.8 132.4c5.4-1.5 8.7-7.1 7.2-12.5s-7.1-8.7-12.5-7.2-8.7 7.1-7.2 12.5c1.4 5.4 7 8.6 12.5 7.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1003",
    className: "st0",
    d: "m290.8 137.6c4-1.1 6.4-5.2 5.3-9.2s-5.2-6.4-9.2-5.3-6.4 5.2-5.3 9.2 5.2 6.4 9.2 5.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1005",
    className: "st1",
    d: "m267.5 141.1c2.5-0.7 4-3.3 3.4-5.8s-3.3-4-5.8-3.4c-2.5 0.7-4 3.3-3.4 5.8s3.2 4 5.8 3.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1007",
    className: "st2",
    d: "m330 86c3.8 6.5 12.1 8.8 18.6 5s8.8-12.1 5-18.6-12.1-8.8-18.6-5-8.8 12.1-5 18.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    className: "st2",
    d: "m299.9 103.3c2.6 4.6 8.4 6.1 13 3.5s6.1-8.4 3.5-13-8.4-6.1-13-3.5c-4.5 2.6-6.1 8.4-3.5 13z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path1011",
    className: "st2",
    d: "m278.5 107.8c-3.3 1.9-4.4 6-2.5 9.3s6 4.4 9.3 2.5 4.4-6 2.5-9.3c-1.8-3.2-6-4.3-9.3-2.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path1013",
    className: "st2",
    d: "m259.4 121.6c-2.1 1.2-2.9 3.9-1.7 6s3.9 2.9 6 1.7 2.9-3.9 1.7-6-3.9-2.9-6-1.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    className: "st3",
    d: "m328.5 59.3c4.8-4.8 4.8-12.5 0-17.3s-12.5-4.8-17.3 0-4.8 12.5 0 17.3c4.7 4.8 12.5 4.8 17.3 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path1017",
    className: "st3",
    d: "m298.6 71.8c-3.5-3.5-9.1-3.5-12.5 0-3.5 3.5-3.5 9.1 0 12.5 3.5 3.5 9.1 3.5 12.5 0 3.5-3.5 3.5-9.1 0-12.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path1019",
    className: "st3",
    d: "m266.6 95.1c-2.4 2.4-2.4 6.3 0 8.7s6.3 2.4 8.7 0 2.4-6.3 0-8.6c-2.4-2.5-6.3-2.5-8.7-0.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path1021",
    className: "st3",
    d: "m251.5 118.9c1.6 1.6 4.2 1.6 5.8 0s1.6-4.2 0-5.8-4.2-1.6-5.8 0-1.6 4.2 0 5.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path1023",
    className: "st4",
    d: "m285.4 38.7c5.5 3.2 12.6 1.3 15.8-4.2s1.3-12.6-4.2-15.8-12.6-1.3-15.8 4.2c-3.3 5.5-1.4 12.6 4.2 15.8-0.1 0 0 0 0 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path1025",
    className: "st4",
    d: "m264.7 58.2c-2.3 3.9-0.9 8.9 3 11.2s8.9 0.9 11.2-3 0.9-8.9-3-11.2c-4-2.3-9-0.9-11.2 3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path1027",
    className: "st4",
    d: "m259.3 83.8c-2.6-1.5-5.9-0.6-7.4 2s-0.6 5.9 2 7.4 5.9 0.6 7.4-2 0.6-5.9-2-7.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path1029",
    className: "st4",
    d: "m246.7 105.6c-1.8-1-4.1-0.4-5.1 1.4s-0.4 4.1 1.4 5.1 4.1 0.4 5.1-1.4 0.4-4.1-1.4-5.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path1031",
    className: "st5",
    d: "m255 25.4c5.8 1.6 11.8-1.9 13.3-7.7 1.6-5.8-1.9-11.8-7.7-13.3s-11.8 1.9-13.3 7.7c-1.6 5.8 1.9 11.8 7.7 13.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path1033",
    className: "st5",
    d: "m245.8 59.6c4 1.1 8.1-1.3 9.2-5.3s-1.3-8.1-5.3-9.2-8.1 1.3-9.2 5.3c-1 4 1.3 8.1 5.3 9.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path1035",
    className: "st5",
    d: "m238.6 86.6c2.7 0.7 5.5-0.9 6.2-3.6s-0.9-5.5-3.6-6.2-5.5 0.9-6.2 3.6c-0.7 2.6 0.9 5.4 3.6 6.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path1037",
    className: "st5",
    d: "m230.6 103.4c-0.5 1.8 0.6 3.7 2.4 4.2s3.7-0.6 4.2-2.4-0.6-3.7-2.4-4.2c-1.9-0.5-3.8 0.6-4.2 2.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path1039",
    className: "st6",
    d: "m222 20.4c5.6 0 10.2-4.6 10.2-10.2s-4.6-10.2-10.2-10.2-10.2 4.6-10.2 10.2c0 5.7 4.6 10.2 10.2 10.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path1041",
    className: "st6",
    d: "m222 42.2c-3.8 0-6.8 3-6.8 6.8s3 6.8 6.8 6.8 6.8-3 6.8-6.8c0-3.7-3-6.8-6.8-6.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path1043",
    className: "st6",
    d: "m226.8 79.3c0-2.6-2.1-4.8-4.8-4.8s-4.8 2.1-4.8 4.8 2.1 4.8 4.8 4.8 4.8-2.2 4.8-4.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path1045",
    className: "st6",
    d: "m222 99.7c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path1047",
    className: "st7",
    d: "m188.7 24.2c5.1-1.4 8.1-6.6 6.7-11.7s-6.6-8.1-11.7-6.7-8.1 6.6-6.7 11.7c1.4 5 6.7 8 11.7 6.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path1049",
    className: "st7",
    d: "m190.4 54c0.9 3.3 4.2 5.2 7.5 4.3s5.2-4.2 4.3-7.5-4.2-5.2-7.5-4.3c-3.2 0.9-5.2 4.3-4.3 7.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path1051",
    className: "st7",
    d: "m199.9 82.9c0.6 2.4 3.1 3.8 5.4 3.1 2.4-0.6 3.8-3.1 3.1-5.4-0.6-2.4-3.1-3.8-5.4-3.1-2.4 0.6-3.7 3-3.1 5.4v0z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path1053",
    className: "st7",
    d: "m207.6 105.1c0.4 1.5 1.9 2.3 3.3 1.9 1.5-0.4 2.3-1.9 1.9-3.3-0.4-1.5-1.9-2.3-3.3-1.9s-2.3 1.8-1.9 3.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path1055",
    className: "st8",
    d: "m157.4 36.5c4.2-2.4 5.7-7.9 3.3-12.1s-7.9-5.7-12.1-3.3-5.7 7.9-3.3 12.1c2.5 4.3 7.9 5.7 12.1 3.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path1057",
    className: "st8",
    d: "m175.1 67.1c2.6-1.5 3.5-4.8 2-7.4s-4.8-3.5-7.4-2-3.5 4.8-2 7.4c1.4 2.6 4.8 3.5 7.4 2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path1059",
    className: "st8",
    d: "m189.5 92.2c2-1.1 2.6-3.6 1.5-5.6s-3.6-2.6-5.6-1.5-2.6 3.6-1.5 5.6c1.2 1.9 3.7 2.6 5.6 1.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path1061",
    className: "st8",
    d: "m201.3 107.8c-0.7-1.1-2.1-1.5-3.3-0.9-1.1 0.7-1.5 2.1-0.9 3.3 0.7 1.1 2.1 1.5 3.2 0.9 1.3-0.7 1.7-2.2 1-3.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path1063",
    className: "st9",
    d: "m130.1 56.6c3.2-3.2 3.2-8.4 0-11.6s-8.4-3.2-11.6 0-3.2 8.4 0 11.6c3.3 3.2 8.5 3.2 11.6 0z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path1065",
    className: "st9",
    d: "m155.2 74.9c-1.9-1.9-4.9-1.9-6.7 0-1.9 1.9-1.9 4.9 0 6.7 1.9 1.9 4.9 1.9 6.7 0s1.8-4.9 0-6.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path1067",
    className: "st9",
    d: "m175.9 97c-1.5-1.5-3.8-1.5-5.3 0s-1.5 3.8 0 5.3 3.8 1.5 5.3 0c1.4-1.5 1.4-3.8 0-5.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "path1069",
    className: "st9",
    d: "m191.3 114.8c-0.8-0.8-2.1-0.7-2.8 0.1-0.8 0.8-0.7 2.1 0.1 2.8s2 0.7 2.8 0c0.7-0.8 0.7-2.1-0.1-2.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path1071",
    className: "st10",
    d: "m98.5 85.7c3.6 2.1 8.2 0.8 10.2-2.7 2.1-3.6 0.8-8.2-2.7-10.2-3.6-2.1-8.2-0.8-10.2 2.7-2.1 3.5-0.9 8.1 2.7 10.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path1073",
    className: "st10",
    d: "m138.1 95.3c-2-1.1-4.4-0.4-5.6 1.5-1.1 2-0.4 4.4 1.5 5.6 2 1.1 4.4 0.5 5.6-1.5 1.1-2 0.4-4.5-1.5-5.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path1075",
    className: "st10",
    d: "m164 111c-1.6-0.9-3.7-0.4-4.6 1.3-0.9 1.6-0.4 3.7 1.3 4.6 1.6 0.9 3.7 0.4 4.6-1.2s0.3-3.7-1.3-4.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path1077",
    className: "st11",
    d: "m360.4 131.9c-9 0-16.4 7.3-16.4 16.4 0 9 7.3 16.4 16.4 16.4 9 0 16.3-7.3 16.4-16.3-0.1-9.1-7.4-16.5-16.4-16.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path1079",
    className: "st11",
    d: "m333.3 148.3c0-6.5-5.2-11.7-11.7-11.7s-11.7 5.2-11.7 11.7 5.2 11.7 11.7 11.7c6.4 0 11.7-5.2 11.7-11.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path1081",
    className: "st11",
    d: "m291.3 140.3c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path1083",
    className: "st12",
    d: "m273 148.3c0-2.9-2.3-5.2-5.2-5.2s-5.2 2.3-5.2 5.2 2.3 5.2 5.2 5.2 5.2-2.3 5.2-5.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path1085",
    className: "st13",
    d: "m359.5 169.5c-8-2.2-16.2 2.6-18.4 10.6s2.6 16.2 10.6 18.4 16.2-2.6 18.4-10.6v-0.1c2.1-7.9-2.7-16.1-10.6-18.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path1087",
    className: "st13",
    d: "m315.5 183.8c5.4 1.5 11-1.8 12.5-7.2s-1.8-11-7.2-12.5-11 1.8-12.5 7.2 1.7 11 7.2 12.5z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path1089",
    className: "st13",
    d: "m286.9 173.4c4 1.1 8.1-1.3 9.2-5.3s-1.3-8.1-5.3-9.2-8.1 1.3-9.2 5.3c-1 4 1.3 8.1 5.3 9.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "path1091",
    className: "st13",
    d: "m265 164.7c2.5 0.7 5.1-0.8 5.8-3.4 0.7-2.5-0.8-5.1-3.4-5.8-2.5-0.7-5.1 0.8-5.8 3.4-0.7 2.4 0.8 5.1 3.4 5.8v0z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "path1093",
    className: "st14",
    d: "m348.6 205.5c-6.5-3.8-14.8-1.5-18.6 5s-1.5 14.8 5 18.6 14.8 1.5 18.6-5c3.7-6.5 1.5-14.8-5-18.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "path1095",
    className: "st14",
    d: "m316.5 202.7c2.6-4.6 1.1-10.4-3.5-13s-10.4-1.1-13 3.5-1.1 10.4 3.5 13c4.5 2.6 10.3 1 13-3.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "path1097",
    className: "st14",
    d: "m287.8 186.2c1.9-3.3 0.8-7.4-2.5-9.3s-7.4-0.8-9.3 2.5-0.8 7.4 2.5 9.3c3.3 1.8 7.4 0.7 9.3-2.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "path1099",
    className: "st14",
    d: "m265.5 173.2c1.2-2.1 0.5-4.8-1.6-6.1-2.1-1.2-4.8-0.5-6.1 1.6s-0.5 4.8 1.6 6.1h0.1c2.1 1.2 4.8 0.5 6-1.6z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "path1101",
    className: "st15",
    d: "m311.1 237.2c-4.8 4.8-4.8 12.5 0 17.3s12.5 4.8 17.3 0 4.8-12.5 0-17.3c-4.7-4.7-12.5-4.7-17.3 0z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "path1103",
    className: "st15",
    d: "m298.6 224.7c3.5-3.5 3.5-9.1 0-12.5-3.5-3.5-9.1-3.5-12.5 0-3.5 3.5-3.5 9.1 0 12.5 3.4 3.5 9 3.5 12.5 0z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "path1105",
    className: "st15",
    d: "m275.3 201.4c2.4-2.4 2.4-6.3 0-8.7s-6.3-2.4-8.7 0-2.4 6.3 0 8.6c2.4 2.5 6.3 2.5 8.7 0.1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "path1107",
    className: "st15",
    d: "m251.5 183.3c1.6 1.6 4.2 1.6 5.8 0s1.6-4.2 0-5.8-4.2-1.6-5.8 0-1.6 4.2 0 5.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "path1109",
    className: "st16",
    d: "m285.4 257.8c-5.5 3.2-7.4 10.3-4.2 15.8s10.3 7.4 15.8 4.2 7.4-10.3 4.2-15.8-10.3-7.4-15.8-4.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "path1111",
    className: "st16",
    d: "m278.8 230.2c-2.3-3.9-7.2-5.3-11.2-3-3.9 2.3-5.3 7.2-3 11.2 2.3 3.9 7.2 5.3 11.2 3 3.9-2.3 5.3-7.3 3-11.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    className: "st16",
    d: "m259.3 212.7c2.6-1.5 3.5-4.8 2-7.4s-4.8-3.5-7.4-2-3.5 4.8-2 7.4 4.8 3.5 7.4 2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "path1115",
    className: "st16",
    d: "m243 184.4c-1.8 1-2.4 3.3-1.4 5.1s3.3 2.4 5.1 1.4 2.4-3.3 1.4-5.1-3.3-2.4-5.1-1.4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "path1117",
    className: "st17",
    d: "m255 271.1c-5.8 1.6-9.3 7.5-7.7 13.3s7.5 9.3 13.3 7.7 9.3-7.5 7.7-13.3c-1.5-5.8-7.5-9.3-13.3-7.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "path1119",
    className: "st17",
    d: "m249.7 251.3c4-1.1 6.4-5.2 5.3-9.2s-5.2-6.4-9.2-5.3-6.3 5.2-5.3 9.2c1.1 4.1 5.2 6.4 9.2 5.3v0z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "path1121",
    className: "st17",
    d: "m244.8 213.5c-0.7-2.7-3.5-4.3-6.2-3.6s-4.3 3.5-3.6 6.2 3.5 4.3 6.2 3.6c2.8-0.6 4.4-3.4 3.6-6.2v0z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "path1123",
    className: "st17",
    d: "m237.1 191.3c-0.5-1.8-2.4-2.9-4.2-2.4s-2.9 2.4-2.4 4.2 2.3 2.9 4.2 2.4c1.8-0.5 2.9-2.4 2.4-4.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "path1125",
    className: "st18",
    d: "m222 276.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2 10.2-4.5 10.2-10.2c0-5.6-4.5-10.2-10.2-10.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "path1127",
    className: "st18",
    d: "m215.2 247.5c0 3.8 3 6.8 6.8 6.8s6.8-3 6.8-6.8-3-6.8-6.8-6.8c-3.7 0-6.8 3-6.8 6.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "path1129",
    className: "st18",
    d: "m222 221.9c2.6 0 4.8-2.1 4.8-4.8s-2.1-4.8-4.8-4.8c-2.6 0-4.8 2.1-4.8 4.8 0.1 2.7 2.2 4.8 4.8 4.8v0z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "path1131",
    className: "st18",
    d: "m222 190.6c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "path1133",
    className: "st19",
    d: "m188.7 272.3c-5.1-1.4-10.3 1.7-11.7 6.7-1.4 5.1 1.7 10.3 6.7 11.7 5.1 1.4 10.3-1.7 11.7-6.7 1.4-5.1-1.6-10.3-6.7-11.7z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "path1135",
    className: "st19",
    d: "m197.9 238.1c-3.3-0.9-6.6 1.1-7.5 4.3-0.9 3.3 1.1 6.6 4.3 7.5 3.3 0.9 6.6-1.1 7.5-4.3s-1-6.6-4.3-7.5z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "path1137",
    className: "st19",
    d: "m205.3 210.5c-2.4-0.6-4.8 0.8-5.4 3.1-0.6 2.4 0.8 4.8 3.1 5.4 2.4 0.6 4.8-0.8 5.4-3.1 0.7-2.3-0.7-4.7-3.1-5.4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    className: "st19",
    d: "m212.9 192.8c0.4-1.5-0.5-3-1.9-3.3s-3 0.5-3.3 1.9 0.5 3 1.9 3.3c1.4 0.4 2.9-0.4 3.3-1.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "path1141",
    className: "st20",
    d: "m157.4 260c-4.2-2.4-9.6-1-12.1 3.2-2.4 4.2-1 9.6 3.2 12.1 4.2 2.4 9.6 1 12.1-3.2s1-9.6-3.2-12.1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "path1143",
    className: "st20",
    d: "m175.1 229.4c-2.6-1.5-5.9-0.6-7.4 2s-0.6 5.9 2 7.4 5.9 0.6 7.4-2 0.6-5.9-2-7.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "path1145",
    className: "st20",
    d: "m185.5 211.4c2 1.1 4.5 0.5 5.6-1.5s0.5-4.5-1.5-5.6-4.5-0.5-5.6 1.5-0.5 4.5 1.5 5.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "path1147",
    className: "st20",
    d: "m200.5 185.4c-1.1-0.7-2.6-0.3-3.2 0.9-0.7 1.1-0.3 2.6 0.9 3.2 1.1 0.7 2.6 0.3 3.2-0.9 0.6-1 0.2-2.5-0.9-3.2v0z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "path1149",
    className: "st21",
    d: "m118.6 239.9c-3.2 3.2-3.2 8.4 0 11.6s8.4 3.2 11.6 0 3.2-8.4 0-11.6-8.4-3.2-11.6 0z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "path1151",
    className: "st21",
    d: "m148.5 214.9c-1.9 1.9-1.9 4.9 0 6.7 1.9 1.9 4.9 1.9 6.7 0s1.9-4.9 0-6.7c-1.8-1.9-4.9-1.9-6.7 0z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    className: "st21",
    d: "m170.6 194.2c-1.5 1.5-1.5 3.8 0 5.3s3.8 1.5 5.3 0 1.5-3.8 0-5.3-3.9-1.5-5.3 0z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    className: "st21",
    d: "m191.3 178.8c-0.8-0.8-2.1-0.7-2.8 0.1-0.8 0.8-0.7 2.1 0.1 2.8s2 0.7 2.8 0c0.7-0.8 0.7-2.1-0.1-2.9z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "path1157",
    className: "st22",
    d: "m98.7 210.6c-3.6 2.1-4.8 6.6-2.7 10.2s6.6 4.8 10.2 2.7 4.8-6.6 2.7-10.2c-2-3.6-6.6-4.8-10.2-2.7z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "path1159",
    className: "st22",
    d: "m134 194.1c-1.9 1.1-2.6 3.6-1.5 5.6 1.1 1.9 3.6 2.6 5.6 1.5 1.9-1.1 2.6-3.6 1.5-5.6-1.1-1.9-3.6-2.6-5.6-1.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "path1161",
    className: "st22",
    d: "m160.6 179.6c-1.6 0.9-2.2 3-1.2 4.6 0.9 1.6 3 2.2 4.6 1.2 1.6-0.9 2.2-3 1.2-4.6-0.9-1.6-3-2.2-4.6-1.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "path1163",
    className: "st23",
    d: "m83.5 124.5h12v46.2h-12zm7.3-20.6c-3.7-1-7.5 1.2-8.5 4.9s1.2 7.5 4.9 8.5 7.5-1.2 8.5-4.9-1.2-7.6-4.9-8.5zm41.8 67.8c-2.9 0-5.8-0.5-8.5-1.7-2.4-1.1-4.5-2.8-6.1-4.9v28.7h-11.7v-69.3h11.6v6.4c1.5-2.3 3.6-4.1 6.1-5.4 2.6-1.3 5.5-2 8.5-2 2.9 0 5.7 0.6 8.4 1.7s5.1 2.8 7.1 4.8c2.1 2.2 3.8 4.8 4.9 7.6 1.3 3.2 1.9 6.5 1.8 9.9 0.1 3.4-0.6 6.8-1.9 10-1.2 2.8-2.9 5.4-5 7.6-3.9 4.2-9.5 6.6-15.2 6.6zm-2.4-11.2c1.7 0 3.4-0.3 5-1 1.5-0.7 2.9-1.6 4.1-2.8s2.1-2.6 2.7-4.1c1.3-3.3 1.3-6.9 0-10.2-0.6-1.5-1.6-2.9-2.7-4.1-1.2-1.2-2.6-2.1-4.1-2.8-1.6-0.7-3.3-1-5-1-3.4 0-6.7 1.4-9.2 3.8-1.2 1.2-2.1 2.6-2.7 4.1-1.3 3.3-1.3 6.9 0 10.1 0.6 1.5 1.5 2.9 2.7 4.1 2.5 2.6 5.8 4 9.2 3.9zm33.1-36h11.6v7.1c1-2.5 2.7-4.6 5-6 2.4-1.3 5-2 7.8-1.9 1.5 0 2.9 0.2 4.3 0.5 1.2 0.3 2.4 0.7 3.5 1.3l-4.3 11.6c-0.8-0.5-1.7-0.9-2.6-1.2-1.2-0.3-2.4-0.5-3.6-0.5-2.7-0.1-5.3 0.8-7.3 2.5-1.8 1.7-2.7 4.5-2.7 8.3v24.4h-11.7zm58.3 47.2c-3.3 0-6.6-0.6-9.7-1.9-2.9-1.2-5.5-3-7.8-5.2-4.5-4.5-7-10.6-7-17 0-3.2 0.6-6.4 1.8-9.4 1.2-2.9 2.9-5.5 5.1-7.7 9.7-9.4 25.1-9.4 34.8 0 4.5 4.5 7.1 10.6 7.1 17 0 3.2-0.6 6.4-1.9 9.3-1.2 2.9-3 5.5-5.1 7.7-2.2 2.2-4.8 4-7.8 5.2-2.9 1.3-6.2 2-9.5 2zm0.1-11.2c1.7 0 3.4-0.3 5-1 1.5-0.7 2.8-1.6 4-2.7 1.2-1.2 2.1-2.6 2.7-4.1 1.3-3.3 1.3-6.9 0-10.1-0.6-1.5-1.5-2.9-2.7-4.1s-2.5-2.1-4-2.7c-3.2-1.4-6.8-1.4-9.9 0-1.5 0.7-2.8 1.6-4 2.7-1.2 1.2-2.1 2.6-2.7 4.1-1.3 3.3-1.3 6.9 0 10.1 0.6 1.5 1.5 2.9 2.7 4.1s2.5 2.1 4 2.7 3.2 1 4.9 1zm-221.7-36h12l9.3 29.5 11-29.5h10.4l10.8 29.5 9.7-29.5h12l-15.7 46.2h-11.1l-11-30.1-11.1 30.1h-11.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.3a7cd3cd274ed8597a6c57b9474a50cf.svg";
export { ForwardRef as ReactComponent };